import {ENTER, ESCAPE} from "@angular/cdk/keycodes"
import {Directive, ElementRef, HostBinding, HostListener, effect, input, output, inject} from "@angular/core"

@Directive({
    selector: "[cmInput]",
})
export class InputDirective {
    readonly $cmInput = input<string | number>(undefined, {alias: "cmInput"})
    private readonly element = inject(ElementRef)

    constructor() {
        this.outlineColor = "none"
        this.border = "1px solid transparent"
        this.borderRadius = "3px"

        effect(() => {
            const value = this.$cmInput()
            if (value !== undefined) {
                this.element.nativeElement.value = value
            }
        })
    }

    readonly valueChange = output<string>({alias: "cmInputChange"})

    @HostBinding("style.border") border: string
    @HostBinding("style.border-radius") borderRadius: string
    @HostBinding("style.box-shadow") boxShadow?: string
    @HostBinding("style.outline-style") outlineColor: string

    @HostListener("focus")
    onFocus() {
        this.border = "1px solid slategrey"
        this.boxShadow = "0 0 2px 0 slategrey"
    }

    @HostListener("blur")
    onBlur() {
        this.border = "1px solid transparent"
        this.boxShadow = "none"
    }

    @HostListener("keydown", ["$event"])
    onKeyDown(event: KeyboardEvent) {
        if (event.keyCode === ENTER && this.element.nativeElement.type !== "textarea") {
            this.element.nativeElement.blur()
        }
        if (event.keyCode === ESCAPE) {
            this.element.nativeElement.blur()
        }
    }

    @HostListener("input")
    onInput(): void {
        this.valueChange.emit(this.element.nativeElement.value)
    }
}
